/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";
import { SwapDummer } from "../SwapDummer";
import "./style.css";

export const TestCompWrap = ({ override = <SwapDummer className="swap-dummer-instance" /> }) => {
  return (
    <div className="test-comp-wrap">
      <div className="inner">{override}</div>
    </div>
  );
};
